// Imports and dependencies
import { Alert, Button, Col, Form, Input, Modal, Row, Select, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useI18n } from '../../Utils/i18n';

const { Text } = Typography;

function PayTitle() {
    const token = useSelector((state) => state.user.token);
    const { t } = useI18n();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'pay_title_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Payslip Title Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Slip Name',
            dataIndex: 'slip_name',
            render: (_, record) => <Tooltip title={record.slip_name || record.name}><span>{record.slip_name || record.name}</span></Tooltip>,
            key: "name",
            width: 360,
            ellipsis: { showTitle: false },
            sorter: true,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: "type",
            sorter: true,
            render: (text, record) => {
                return <Tag color={record.type === 'cost' ? 'red' : 'green'}>{record.type}</Tag>;
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => {
                return record.created_at ? (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>) : "-";
            }
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => {
                return record.updated_at ? (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>) : "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Tooltip title="Edit">
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                                <EditOutlined />
                            </Button>
                        </Tooltip>

                        <Tooltip title="Delete">
                            <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                                <DeleteOutlined />
                            </Button>
                        </Tooltip>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'pay_title_id';
        getApi("GET", `/paytitle?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'paytitle');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.error(e);
        });
    }

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/paytitle/' + v.pay_title_id, null),
        });
    }

    const openModal = async (type, data) => {
        if (type === 'edit') {
            setdataModal(data);
            form.setFieldsValue({
                name: data.slip_name || data.name,
                type: data.type,
            });
            setIsModal(true);
        } else {
            setIsModal(true);
        }
    }

    const onFinish = (ev) => {
        const payload = { ...ev, slip_name: ev.name };
        if (dataModal != null) {
            postApi("PUT", '/paytitle/' + dataModal.pay_title_id, payload);
        } else {
            postApi("POST", '/paytitle', payload);
        }
    }

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>{t('payslipTitle')}</h3>
            <Row gutter={[12, 12]} align="middle" justify="space-between" style={{ marginBottom: 12 }}>
                <Col xs={24} md={13} lg={10}>
                    <Input.Search
                        value={search}
                        placeholder={t('searchPlaceholderTitle')}
                        allowClear
                        enterButton={t('search')}
                        onChange={(e) => setSearch(e.target.value)}
                        onSearch={(value) => searchData(value)}
                    />
                </Col>
                <Col xs={24} flex="none" style={{ marginLeft: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => { openModal('add', null); }}>
                        <b>{t('add')}</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Payslip Title Data" open={isModal} onOk={form.submit} onCancel={() => closeModal()} okText="Save" >
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Alert style={{ marginBottom: 12 }} type="info" showIcon message="Gunakan Slip Name yang singkat dan mudah dibaca pada slip gaji. Nama ini akan dipakai di form payroll, slip gaji PDF, dan email slip gaji." />
                    <Form.Item
                        name="name"
                        label="Slip Name"
                        rules={[{ required: true, message: 'Name is required!' }]}
                    >
                        <Input placeholder='Enter payslip title' />
                    </Form.Item>
                    <Form.Item
                        name="type"
                        label="Type"
                        rules={[{ required: false }]}
                    >
                        <Select
                            placeholder="Select Type"
                            options={[
                                { value: 'benefit', label: 'Benefit' },
                                { value: 'cost', label: 'Cost' }
                            ]}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default PayTitle;
